export enum ExceptionsErrorType {
  NotFound = 'NOT_FOUND',
  QuotationNotFound = 'QUOTATION_NOT_FOUND',
  QuoteExpired = 'QUOTE_EXPIRED',
}
